import script from "./Buyers.vue?vue&type=script&setup=true&lang=js"
export * from "./Buyers.vue?vue&type=script&setup=true&lang=js"

import "./Buyers.vue?vue&type=style&index=0&id=7f14954c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f14954c"]])

export default __exports__